import { ButtonSecondary } from "components/Clickable/Buttons";
import {
    AddToFavoritesPDPContent,
    AddToFavoritesRulesetContent,
} from "components/VisualConfigurator/AddToFavoritesContent";
import { useState } from "react";

import HeartIcon from "../../public/svg/heart.svg";
import { Modal } from "../Modal";

import styles from "./add-to-favorites-button.module.scss";

const ariaLabel = "add-to-favorite-label";

export const AddToFavoritesButton = ({
    className,
    isRuleset,
}: {
    className?: string;
    isRuleset?: boolean;
}) => {
    const [showFavoritesModal, setShowFavoritesModal] = useState(false);

    const classes = className ? `${className}` : styles.button;

    return (
        <>
            <ButtonSecondary
                className={classes}
                type="button"
                onClick={() => setShowFavoritesModal(true)}
            >
                Add to Favorite
                <HeartIcon />
            </ButtonSecondary>

            <Modal
                isOpen={showFavoritesModal}
                close={() => setShowFavoritesModal(false)}
                labelId={ariaLabel}
            >
                {isRuleset ? (
                    <AddToFavoritesRulesetContent
                        labelId={ariaLabel}
                        intent="Add"
                    />
                ) : (
                    <AddToFavoritesPDPContent
                        labelId={ariaLabel}
                        intent="Add"
                    />
                )}
            </Modal>
        </>
    );
};
